import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    Checkbox,
    Stack,
    Link,
    Button,
    Heading,
    Text,
    useColorModeValue,
  } from '@chakra-ui/react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../redux/users/user_actions';
import { useNavigate } from 'react-router-dom';

import {toaster, Toaster } from 'react-hot-toast';

  
  export default function Loginpage() {
    const {auth, token, loading, error} = useSelector((state)=>state.userReducer)
    const nav = useNavigate()
    if(auth)
    {
        nav("/notes")
    }
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const dispatch = useDispatch()
    const handleLogin = ()=>{
        dispatch(getUser({email, password}))                
    }


    console.log(" Error Login ",error);    

    return (
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}
        >
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'}>Inicia sesión en tu cuenta</Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
            para disfrutar de todas nuestras funciones interesantes ✌️
            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
              <FormControl id="email">
                <FormLabel>Correo Electrónico</FormLabel>
                <Input value={email} onChange={(e)=>setEmail(e.target.value)} type="email" />
              </FormControl>
              <FormControl id="password">
                <FormLabel>Contraseña</FormLabel>
                <Input value={password} onChange={(e)=>setPassword(e.target.value)} type="password" />
              </FormControl>
              <Stack spacing={10}>
                <Button
                  onClick={handleLogin}
                  // bg={'blue.400'}
                  bg={"#3077d5"}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}>
                  Iniciar Sesión
                </Button>
              </Stack>
            </Stack>
            
            <Toaster />


          </Box>
        </Stack>
      </Flex>
    );
  }